<rbb-side-menu [groups]="sideMenuGroups"/>

<router-outlet/>
